import { TOP, BOTTOM, LEFT, RIGHT, BEFORE, AFTER } from 'layout-dnd-utils/constants';

// Drag types
export const DRAG_TYPES = {
  EXISTING_ITEM: 'EXISTING_ITEM',
  RESIZE_HANDLE: 'RESIZE_HANDLE',
  ADD_MODULE: 'ADD_MODULE',
  ADD_BUILDING_BLOCK: 'ADD_BUILDING_BLOCK',
  MULTI_ITEM: 'MULTI_ITEM'
};

// Drop target types
export const dropTypes = {
  MOVE_SECTION_BEFORE: 'MOVE_SECTION_BEFORE',
  MOVE_SECTION_AFTER: 'MOVE_SECTION_AFTER',
  INSERT_INTO_EMPTY_STACK: 'INSERT_INTO_EMPTY_STACK',
  INSERT_ELEMENT_BEFORE: 'INSERT_ELEMENT_BEFORE',
  INSERT_ELEMENT_AFTER: 'INSERT_ELEMENT_AFTER',
  INSERT_INTO_EMPTY_GRID_LAYOUT: 'INSERT_INTO_EMPTY_GRID_LAYOUT',
  INSERT_INTO_TABLE_CELL: 'INSERT_INTO_TABLE_CELL',
  APPEND_GRID_CELL: 'APPEND_GRID_CELL',
  INSERT_AFTER_TABLE_CELL: 'INSERT_AFTER_TABLE_CELL',
  WRAP_AND_INSERT_ABOVE_CONTAINER: 'WRAP_AND_INSERT_ABOVE_CONTAINER',
  WRAP_AND_INSERT_BELOW_CONTAINER: 'WRAP_AND_INSERT_BELOW_CONTAINER',
  WRAP_AND_INSERT_LEFT_OF_CONTAINER: 'WRAP_AND_INSERT_LEFT_OF_CONTAINER',
  WRAP_AND_INSERT_RIGHT_OF_CONTAINER: 'WRAP_AND_INSERT_RIGHT_OF_CONTAINER',
  ON_PEGBOARD: 'ON_PEGBOARD',
  CENTER_ON_PEGBOARD: 'CENTER_ON_PEGBOARD',
  CLOSEST_NON_OVERLAPPING_ON_PEGBOARD: 'CLOSEST_NON_OVERLAPPING_ON_PEGBOARD',
  MULTI_ITEM_ON_PEGBOARD: 'MULTI_ITEM_ON_PEGBOARD',
  // Layout Section Actions
  PREPEND_ROW: 'PREPEND_ROW',
  APPEND_ROW: 'APPEND_ROW',
  INSERT_COLUMN_AFTER: 'INSERT_COLUMN_AFTER',
  INSERT_COLUMN_BEFORE: 'INSERT_COLUMN_BEFORE',
  INSERT_INTO_EMPTY_ROW: 'INSERT_INTO_EMPTY_ROW',
  INSERT_INTO_EMPTY_COLUMN: 'INSERT_INTO_EMPTY_COLUMN',
  INSERT_ROW_AFTER: 'INSERT_ROW_AFTER',
  INSERT_ROW_BEFORE: 'INSERT_ROW_BEFORE'
};
export const dropTargetOrientation = {
  HORIZONTAL: 'HORIZONTAL',
  VERTICAL: 'VERTICAL',
  INSIDE: 'INSIDE'
};
export const DropTargetLocations = {
  TOP,
  BOTTOM,
  LEFT,
  RIGHT,
  BEFORE,
  AFTER,
  INSIDE: 'INSIDE',
  SPLIT_ROW_BEFORE: 'SPLIT_ROW_BEFORE',
  SPLIT_ROW_AFTER: 'SPLIT_ROW_AFTER'
};
export const BUILDING_BLOCK_TYPES = {
  HORIZONTAL_STACK: 'HORIZONTAL_STACK',
  VERTICAL_STACK: 'VERTICAL_STACK',
  TABLE: 'TABLE'
};

// Resize handle types
export const ResizeHandleTypes = {
  RESIZE_HANDLE_LEFT: 'RESIZE_HANDLE_LEFT',
  RESIZE_HANDLE_RIGHT: 'RESIZE_HANDLE_RIGHT',
  RESIZE_HANDLE_BETWEEN: 'RESIZE_HANDLE_BETWEEN'
};

// Resize handle dimensions
export const ResizeHandleDimensions = {
  HEIGHT_SCALE: 0.8,
  WIDTH: 10
};
export const MODULE_DRAG_HANDLE = 'MODULE_DRAG_HANDLE';
export const EMPTY_CONTAINER_DRAG_HANDLE = 'EMPTY_CONTAINER_DRAG_HANDLE';
export const COLUMN_DRAG_HANDLE = 'COLUMN_DRAG_HANDLE';
export const ROW_DRAG_HANDLE = 'ROW_DRAG_HANDLE';
export const SECTION_DRAG_HANDLE = 'SECTION_DRAG_HANDLE';
export const INSERT_NEW_SECTION_HANDLE = 'INSERT_NEW_SECTION_HANDLE';
export const TABLE_DRAG_HANDLE = 'TABLE_DRAG_HANDLE';
export const REUSABLE_BLOCK_DRAG_HANDLE = 'REUSABLE_BLOCK_DRAG_HANDLE';
export const GLOBAL_BLOCK_DRAG_HANDLE = 'GLOBAL_BLOCK_DRAG_HANDLE';
export const VERTICAL_STACK_DRAG_HANDLE = 'VERTICAL_STACK_DRAG_HANDLE';
export const HORIZONTAL_STACK_DRAG_HANDLE = 'HORIZONTAL_STACK_DRAG_HANDLE';
export const OffscreenPosition = {
  TOP: -1000,
  LEFT: -1000
};
export const DRAG_PREVIEW_HEIGHT_PX = 80;
export const DRAG_PREVIEW_WIDTH_PX = 80;
export const SCROLL_DURING_DRAG_AMOUNT = 50;
export const Z_INDEX_MAX_LAYERS = {
  LEVEL_1: 2147483598,
  LEVEL_2: 2147483599,
  LEVEL_3: 2147483600,
  LEVEL_4: 2147483640,
  LEVEL_5: 2147483647
};
export const Z_INDEX_INPAGE = {
  REPEATER_ITEM_OUTLINE: 9998,
  REPEATER_DRAG_GHOST: 10000,
  REPEATER_DROP_INDICATOR: 10001
};
export const ALIGNMENT_GUIDE_TYPES = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
};
export const RELATIVE_ALIGNMENT_GUIDE_TYPES = {
  COLUMN_ALIGN: 'column-align',
  ROW_ALIGN: 'row-align'
};
export const SPACING_INDICATOR_TYPES = {
  EQUAL_SPACING: 'equal-spacing'
};